// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._1vqgg17y .mvng-hide-controls{transition:opacity .3s}._16jlkb7n{flex-grow:1}
._18m9ewfl{overflow-y:visible}
._1bah1h6o{justify-content:center}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._1o9zkb7n{flex-shrink:1}
._1reoewfl{overflow-x:visible}
._4cvr1h6o{align-items:center}
._4t3i1osq{height:100%}
._bq91idpf .mvng-hide-controls{opacity:0}
._bq91kb7n .mvng-hide-controls{opacity:1}
._i0dlf1ug{flex-basis:0%}
._kqswh2mm{position:relative}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-ui/dist/esm/inactivityDetector/styled-compiled.compiled.css"],"names":[],"mappings":";AACA,+BAA+B,sBAAsB,CAAC,WAAW,WAAW;AAC5E,WAAW,kBAAkB;AAC7B,WAAW,sBAAsB;AACjC,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,aAAa;AACxB,WAAW,kBAAkB;AAC7B,WAAW,kBAAkB;AAC7B,WAAW,WAAW;AACtB,+BAA+B,SAAS;AACxC,+BAA+B,SAAS;AACxC,WAAW,aAAa;AACxB,WAAW,iBAAiB","sourcesContent":["\n._1vqgg17y .mvng-hide-controls{transition:opacity .3s}._16jlkb7n{flex-grow:1}\n._18m9ewfl{overflow-y:visible}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1o9zkb7n{flex-shrink:1}\n._1reoewfl{overflow-x:visible}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}\n._bq91idpf .mvng-hide-controls{opacity:0}\n._bq91kb7n .mvng-hide-controls{opacity:1}\n._i0dlf1ug{flex-basis:0%}\n._kqswh2mm{position:relative}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
